module.exports = __webpack_public_path__ + "static/media/euro.a6f38c12.svg";